const n = (e = 0) => new Promise((o) => {
  window.addEventListener("scroll", () => {
    t() && o(!0);
  });
}), t = () => window.scrollY / (document.body.scrollHeight - window.innerHeight) > 0.5;
export {
  n as default
};
